export default {
  data() {
    return {
    }
  },
  methods: {
    toast(options, append = false) {
      let id = options.id != null && options.id != undefined ? "toast-" + options.id : 'default-toast';
      let message = options.message != null && options.message != undefined ? options.message : 'Body Message';
      let title = options.title != null && options.title != undefined ? options.title : 'Title';
      let variant = options.variant != null && options.variant != undefined ? options.variant : '';
      let position = options.position != null && options.position != undefined ? options.position : 'b-toaster-bottom-center';
      let autoHideDelay = options.autoHideDelay != null && options.autoHideDelay != undefined ? options.autoHideDelay : 0;
      let noAutoHide = autoHideDelay > 0 ? false : true;


      this.$bvToast.hide(id);
      this.$bvToast.toast(message, {
        id: id,
        title: title,
        toaster: position,
        variant: variant,
        solid: true,
        appendToast: append,
        autoHideDelay: autoHideDelay,
        noAutoHide: noAutoHide,
      })

    },
    hideToast(options) {
      let id = options != null && options.id != null && options.id != undefined ? "toast-" + options.id : 'default-toast';
      let timeout = options != null && options.autoHideDelay != null && options.autoHideDelay != undefined ? options.autoHideDelay : 2000;
      setTimeout(() => {
        this.$bvToast.hide(id);
      }, timeout);
    }
  }
};
